// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2uWlh","title":"AfterBackImages_title__ZeKtM","images":"AfterBackImages_images__22iGX"};